import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Children } from 'react';
import { __DEV__ } from '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import ButtonGroup from '../../ButtonGroup/index.esm.js';
import { useModalContext } from '../context.esm.js';

var ModalFooter = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _useModalContext = useModalContext(),
      size = _useModalContext.size;

  var children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["children"]);

  var childCount = Children.toArray(children).length;
  var fullWidthSizes = ['max-w-xs', 'max-w-sm'];

  if (childCount === 2) {
    fullWidthSizes.push('max-w-md');
  }

  var fullWidth = fullWidthSizes.includes(size);
  return React__default.createElement(ButtonGroup, _extends({
    ref: ref,
    as: "footer",
    space: "space-x-4",
    padding: "p-4",
    borderWidth: "border-t",
    borderColor: "border-gray-200",
    justifyContent: "justify-end",
    fullWidth: fullWidth
  }, rest), children);
});

if (__DEV__) {
  ModalFooter.displayName = 'ModalFooter';
}

export default ModalFooter;
//# sourceMappingURL=index.esm.js.map
